
let Coupon = {
  useCouponCode: async (couponCode) => {
    // クーポンコードが空の場合はエラーをスローする
    if (couponCode === '') {
      throw new Error('クーポンコードを入力してください。');
    }

    // APIエンドポイントのURL
    var apiUrl = '/wp-json/fms/v1/coupon/use';

    // APIリクエストのデータ
    var requestData = {
      coupon_code: couponCode
    };

    try {
      // APIリクエストを送信
      const response = await $.ajax({
        url: apiUrl,
        method: 'POST',
        data: requestData
      });

      // APIレスポンスが成功の場合はレスポンスを返す
      if (response.success) {
        return response;
      } else {
        // APIレスポンスがエラーの場合はエラーをスローする
        throw new Error(response.message);
      }
    } catch (error) {
      // APIリクエストが失敗した場合はエラーをスローする
      throw new Error('クーポンコードの使用に失敗しました。');
    }
  },


  /**
   * 指定したユーザーが使用したクーポン一覧を取得する関数
   * 
   * @param {string} userKey ユーザーキー
   * @returns {Promise} APIレスポンスを含むPromiseオブジェクト
   */
  used: async () => {

    // APIエンドポイントのURL
    const apiUrl = '/wp-json/fms/v1/coupon/used';

    try {
      const response = await $.ajax({
        url: apiUrl,
        method: 'GET',
        dataType: 'json'
      });

      if (response.success) {
        return response.data;
      } else {
        throw new Error(response.message);
      }
    } catch (error) {
      throw new Error('Failed to fetch used coupons.');
    }
  }
 
}

export default Coupon;
